import { useParams, useNavigate } from "react-router-dom";
import KcViewer from "@/components/kc/KcViewer";
import { API_BASE } from "@/lib/api";

// Full-screen KC Test Bench result screen. KcViewer talks to /kc/docs/* via its
// default cookie-authenticated fetch (API_BASE carries the backend origin).
export default function KcViewerPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <div className="h-[calc(100vh-56px)]">
      <KcViewer docId={id} apiBase={API_BASE} onBack={() => navigate("/kc-test")} />
    </div>
  );
}
